// extracted by mini-css-extract-plugin
export var buttons = "PlaceOrderModal-module--buttons--frdBO";
export var container = "PlaceOrderModal-module--container--ynNby";
export var welcomeContent = "PlaceOrderModal-module--welcomeContent--KiCWn";